import { render, staticRenderFns } from "./ConfirmDob.vue?vue&type=template&id=41551e84"
import script from "./ConfirmDob.vue?vue&type=script&lang=js"
export * from "./ConfirmDob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports